export const LIST_HEADERS_TEST_IDS = {
  header: (category: string, isNoCategory?: boolean) => `dropdownListCategory-${isNoCategory ? 'others' : category}`,
  toggle: (headerTestId: string) => `${headerTestId}-toggle`,
  chevron: (headerTestId: string) => `${headerTestId}-chevron`,
};
